import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

declare const __COMMIT_HASH__: string;

const CHANNEL_NAME = "app-version-channel";
const MESSAGE_NEW_VERSION = "new-version";
const MESSAGE_REFRESH_ALL = "refresh-all";
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const LAST_CHECK_KEY = "version-check-timestamp";

export const useVersionChecker = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const location = useLocation();

    const checkVersion = useCallback(async () => {
        const now = Date.now();
        const lastCheck = Number(localStorage.getItem(LAST_CHECK_KEY) || 0);
        if (now - lastCheck < CHECK_INTERVAL_MS) return;
        localStorage.setItem(LAST_CHECK_KEY, String(now));

        try {
            const response = await fetch(`/version.json?_=${now}`);
            const data = await response.json();

            if (data.version && data.version !== __COMMIT_HASH__) {
                setUpdateAvailable(true);
                const channel = new BroadcastChannel(CHANNEL_NAME);
                channel.postMessage(MESSAGE_NEW_VERSION);
                channel.close();
            }
        } catch {
            // Silently fail - version check is not critical
        }
    }, []);

    const refreshAllTabs = useCallback(() => {
        const channel = new BroadcastChannel(CHANNEL_NAME);
        channel.postMessage(MESSAGE_REFRESH_ALL);
        channel.close();
        window.location.reload();
    }, []);

    useEffect(() => {
        checkVersion();
    }, [location.pathname, checkVersion]);

    useEffect(() => {
        const channel = new BroadcastChannel(CHANNEL_NAME);

        channel.onmessage = (event) => {
            if (event.data === MESSAGE_NEW_VERSION) {
                setUpdateAvailable(true);
            } else if (event.data === MESSAGE_REFRESH_ALL) {
                window.location.reload();
            }
        };

        return () => channel.close();
    }, []);

    return { updateAvailable, refreshAllTabs };
};

